import { render, staticRenderFns } from "./pengajuan-bimbingan.vue?vue&type=template&id=e5e86ef2"
import script from "./pengajuan-bimbingan.vue?vue&type=script&lang=js"
export * from "./pengajuan-bimbingan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports